<script lang="ts">
  import Map from '@anoram/leaflet-svelte'
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkLeafletMap from "./BookmarkLeafletMap.svelte";
  import Card from "../../Core/Card.svelte";
  import { BelowMapisdisplayingtheworldmap, LeafletMaps } from "../../../utils/Constant/Constant";
  let options = {
    center: [13, 80],
    markers: [
      {
        lat: 13,
        lng: 80,
      },
    ],
    mapID: 'map',
  }

</script>
<BookmarkLeafletMap />
<Container fluid={true}>
    <Row>
      <Col sm="12">
        <Card>
          <div slot="customheader">
            <h5>{LeafletMaps}</h5>
            <span>{BelowMapisdisplayingtheworldmap}</span>
          </div>
          <div slot="contentbody">
            <div class="map">
              <Map {options} />
            </div>
          </div>
        </Card>
      </Col>
    </Row>
</Container> 
    